// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"39960e8f","465":"5c0c9276","982":"5939968a"}[chunkId] + ".chunk.js";
};